import { render, staticRenderFns } from "./kpiMappingTable.vue?vue&type=template&id=0a38accf&"
import script from "./kpiMappingTable.vue?vue&type=script&lang=js&"
export * from "./kpiMappingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports